/* Find your match quiz (sections/quiz-match.liquid). Answers carry tokens; products are scored against them. */
(function () {
  var root = document.querySelector("[data-quiz-root]");
  if (!root) return;
  var qs = function (s, el) { return (el || root).querySelector(s); };
  var qsa = function (s, el) { return Array.prototype.slice.call((el || root).querySelectorAll(s)); };
  var products = JSON.parse(qs("[data-quiz-data]").textContent);
  var copy = JSON.parse(qs("[data-quiz-copy]").textContent);
  var card = qs("[data-quiz]"), results = qs("[data-quiz-results]");
  var questions = qsa("[data-q]"), backBtn = qs("[data-quiz-back]");
  var STORE = "thb-quiz";
  var picks = {}; // question index -> answer index
  var current = 0;

  var esc = function (s) { var d = document.createElement("div"); d.textContent = s == null ? "" : String(s); return d.innerHTML; };
  var plain = function (s) { var x = String(s).replace(/^[^A-Za-z0-9]+/, "").trim(); return x.charAt(0).toLowerCase() + x.slice(1); }; // drops a leading emoji, lowercases for use mid-sentence
  var answersOf = function (q) { return qsa(".quiz__ans", q); };

  function tokens() {
    var t = { need: [], needLabel: "", format: "", formatLabel: "", thc: "any", size: 1, pet: false };
    Object.keys(picks).forEach(function (qi) {
      var btn = answersOf(questions[qi])[picks[qi]];
      if (!btn) return;
      var label = plain(btn.textContent);
      (btn.getAttribute("data-tokens") || "").split(/\s+/).forEach(function (tok) {
        var kv = tok.split(":"), k = kv[0], v = kv[1];
        if (k === "need" && v) { t.need.push(v); t.needLabel = label; }
        else if (k === "format" && v && v !== "any") { t.format = v; t.formatLabel = label; }
        else if (k === "thc" && v) t.thc = v;
        else if (k === "size" && v) t.size = parseInt(v, 10) || 1;
        else if (k === "pet") { t.pet = true; t.needLabel = label; }
      });
    });
    return t;
  }

  function visible() {
    var pet = tokens().pet;
    return questions.filter(function (q) {
      var a = q.getAttribute("data-audience");
      return a === "all" || (a === "pets" ? pet : !pet);
    });
  }

  function show(i, focus) {
    var list = visible();
    current = i;
    questions.forEach(function (q) { q.hidden = q !== list[i]; });
    var step = qs("[data-quiz-step]");
    step.textContent = (step.getAttribute("data-template") || "").replace("[n]", i + 1).replace("[total]", list.length);
    qs("[data-quiz-bar]").style.width = Math.round((i / list.length) * 100) + "%";
    backBtn.hidden = i === 0;
    if (focus) { var lg = qs(".quiz__legend", list[i]); if (lg) lg.focus({ preventScroll: true }); }
  }

  function pickVariant(p, size) {
    var avail = p.v.filter(function (v) { return v.a; });
    var mg = function (v) { var m = String(v.t).replace(/,/g, "").match(/(\d+(?:\.\d+)?)\s*mg/i); return m ? parseFloat(m[1]) : null; };
    var sizes = [];
    avail.forEach(function (v) { var n = mg(v); if (n != null && sizes.indexOf(n) < 0) sizes.push(n); });
    sizes.sort(function (a, b) { return a - b; });
    if (sizes.length < 2) return { v: avail[0] || p.v[0], size: null };
    var want = sizes[Math.min(size, sizes.length) - 1];
    var v = avail.filter(function (x) { return mg(x) === want; })[0];
    return { v: v, size: want + "mg" };
  }

  function rank(t) {
    var has = function (arr, x) { return arr.indexOf(x) >= 0; };
    var pool = products.filter(function (p) {
      var isPet = has(p.tags, "pet");
      if (t.pet !== isPet) return false;
      if (t.thc === "free" && !has(p.tags, "thc-free")) return false;
      return true;
    });
    pool.forEach(function (p, i) {
      var needHit = t.need.some(function (n) { return has(p.c, n); });
      var fmtHit = t.format && has(p.c, t.format);
      var gentle = t.size === 1 && has(p.tags, "high-potency") ? -3 : 0; // new to CBD: start lower
      var daily = has(p.c, "daily-wellness") ? 0.5 : 0; // filler picks lean on everyday products
      p._s = (needHit || t.pet ? 10 : 0) + (fmtHit ? 4 : 0) + gentle + daily - i / 1000;
      p._need = needHit || t.pet; p._fmt = fmtHit;
    });
    return pool.sort(function (a, b) { return b._s - a._s; });
  }

  function why(p, t, pick) {
    var lines = [];
    if (p._need && t.needLabel && copy.need) lines.push(copy.need.replace("[answer]", t.needLabel));
    if (p._fmt && t.formatLabel && copy.format) lines.push(copy.format.replace("[answer]", t.formatLabel));
    if (p.tags.indexOf("thc-free") >= 0 && copy.free) lines.push(copy.free);
    else if (p.tags.indexOf("contains-thc") >= 0 && copy.thc) lines.push(copy.thc);
    if (pick.size && copy.size) lines.push(copy.size.replace("[size]", pick.size));
    if (pick.v.coa && copy.lab) lines.push(copy.lab);
    return lines;
  }

  function topCard(p, t) {
    var pick = pickVariant(p, t.size), v = pick.v;
    var url = p.u + (p.v.length > 1 ? "?variant=" + v.id : "");
    var img = p.img ? '<a class="quiz-top__media" href="' + esc(url) + '" tabindex="-1" aria-hidden="true"><img src="' + esc(p.img) + '" alt="' + esc(p.alt) + '" width="720" height="720" loading="lazy"></a>' : "";
    var lis = why(p, t, pick).map(function (l) { return "<li>" + esc(l) + "</li>"; }).join("");
    var buy = v.a
      ? '<button type="button" class="btn btn--primary" data-quick-add="' + v.id + '">' + esc(copy.add) + "</button>"
      : '<span class="btn btn--outline" aria-disabled="true">' + esc(copy.sold) + "</span>";
    return '<article class="quiz-top">' + img +
      '<div class="quiz-top__body"><p class="quiz-top__badge">' + esc(copy.top) + "</p>" +
      '<p class="pc__brand">' + esc(p.b) + "</p>" +
      '<p class="h2 hd quiz-top__title"><a href="' + esc(url) + '">' + esc(p.t) + "</a></p>" +
      (p.m ? '<p class="quiz-top__meta">' + esc(p.m) + "</p>" : "") +
      (lis ? '<ul class="quiz-top__why" role="list">' + lis + "</ul>" : "") +
      '<p class="quiz-top__price"><strong>' + esc(v.p) + "</strong>" + (v.cp ? " <s>" + esc(v.cp) + "</s>" : "") +
      (p.v.length > 1 ? ' <span class="muted">' + esc(v.t) + "</span>" : "") + "</p>" +
      '<div class="quiz-top__ctas">' + buy + '<a class="btn btn--outline" href="' + esc(url) + '">' + esc(copy.view) + "</a></div>" +
      (v.coa ? '<a class="quiz-top__coa" href="' + esc(v.coa) + '" target="_blank" rel="noopener">' + esc(copy.coa) + "</a>" : "") +
      "</div></article>";
  }

  function finish(scroll) {
    var t = tokens(), list = rank(t);
    var top = qs("[data-quiz-top]"), more = qs("[data-quiz-more]");
    top.innerHTML = list.length ? topCard(list[0], t) : "";
    qs("[data-quiz-empty]").hidden = list.length > 0;
    more.innerHTML = "";
    list.slice(1, 4).forEach(function (p) {
      var tpl = root.querySelector('template[data-quiz-card="' + p.h + '"]');
      if (tpl) more.appendChild(tpl.content.cloneNode(true));
    });
    qs("[data-quiz-more-wrap]").hidden = !more.children.length;
    var tagInput = qs("[data-quiz-tags]");
    if (tagInput) {
      var pre = root.getAttribute("data-tag-prefix") || "quiz";
      var extra = (t.pet ? ["pets"] : t.need.slice(0, 1)).map(function (n) { return pre + "-" + n; });
      tagInput.value = [pre].concat(extra).join(",");
    }
    card.hidden = true; results.hidden = false;
    try { sessionStorage.setItem(STORE, JSON.stringify(picks)); } catch (e) {}
    var h = qs("[data-quiz-results-heading]");
    if (scroll) { results.scrollIntoView({ behavior: "smooth", block: "start" }); h.focus({ preventScroll: true }); }
  }

  root.addEventListener("click", function (e) {
    var ans = e.target.closest(".quiz__ans");
    if (ans) {
      var q = ans.closest("[data-q]"), qi = parseInt(q.getAttribute("data-q"), 10);
      answersOf(q).forEach(function (b, i) { b.setAttribute("aria-pressed", b === ans ? "true" : "false"); if (b === ans) picks[qi] = i; });
      // drop answers to questions that no longer apply (e.g. switched between pet and people)
      var vis = visible();
      Object.keys(picks).forEach(function (k) { if (vis.indexOf(questions[k]) < 0) delete picks[k]; });
      var idx = vis.indexOf(q);
      setTimeout(function () { if (idx + 1 < vis.length) show(idx + 1, true); else finish(true); }, 180);
      return;
    }
    if (e.target.closest("[data-quiz-back]")) { if (current > 0) show(current - 1, true); return; }
    if (e.target.closest("[data-quiz-retake]")) {
      picks = {};
      try { sessionStorage.removeItem(STORE); } catch (err) {}
      qsa(".quiz__ans").forEach(function (b) { b.setAttribute("aria-pressed", "false"); });
      results.hidden = true; card.hidden = false; show(0, true);
      card.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  });

  // Coming back from the email signup (the form reloads the page): restore the results.
  var saved = null;
  try { saved = JSON.parse(sessionStorage.getItem(STORE) || "null"); } catch (e) {}
  if (saved && (qs("[data-quiz-posted]") || /customer_posted|contact_posted|form_type/.test(location.search) || qs(".quiz__err"))) {
    picks = saved;
    Object.keys(picks).forEach(function (k) { var b = questions[k] && answersOf(questions[k])[picks[k]]; if (b) b.setAttribute("aria-pressed", "true"); });
    finish(false);
    var form = document.getElementById("quiz-email");
    if (form) form.scrollIntoView({ block: "center" });
  } else {
    show(0, false);
  }
})();
